// import router from '../../router'
import {
  NS_CLINICS_SEARCH, NS_CLINICS_SEARCH_SUCCESS, NS_CLINICS_SEARCH_FAILURE, NS_CLINIC_SEARCH, NS_CLINIC_SEARCH_SUCCESS, NS_CLINIC_SEARCH_FAILURE, NS_CLINIC_MATCHING, NS_CLINIC_MATCHING_SUCCESS, NS_CLINIC_MATCHING_FAILURE, NS_CLINIC_AUTOCOMPLETE_CLEAR
} from './mutation-types'

export default {
  state: {
    clinics: null,
    clinic: null
  },
  getters: {
    ns_clinics: state => {
      return state.clinics
    },
    ns_clinic: state => {
      return state.clinic
    }
  },
  actions: {
    [NS_CLINICS_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/clinics'
      var callback = () => {}
      var data = {}
      if (params.data) {
        data = params.data
      }
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_CLINICS_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_CLINICS_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_CLINIC_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/clinics/' + params.data.ns_clinic
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_CLINIC_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_CLINIC_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_CLINIC_MATCHING] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/clinics/matching'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiPost', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_CLINIC_MATCHING_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_CLINIC_MATCHING_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_CLINIC_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(NS_CLINIC_AUTOCOMPLETE_CLEAR)
      }, sleep)
    }
  },
  mutations: {
    [NS_CLINICS_SEARCH_FAILURE] (state, data) {
      console.log('NS_CLINICS_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_CLINICS_SEARCH_SUCCESS] (state, params) {
      console.log('NS_CLINICS_SEARCH_SUCCESS')
      state.clinics = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_CLINIC_SEARCH_FAILURE] (state, data) {
      console.log('NS_CLINIC_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_CLINIC_SEARCH_SUCCESS] (state, params) {
      console.log('NS_CLINIC_SEARCH_SUCCESS')
      state.clinic = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_CLINIC_MATCHING_SUCCESS] (state, params) {
      console.log('NS_CLINIC_MATCHING_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    [NS_CLINIC_MATCHING_FAILURE] (state, data) {
      console.log('NS_CLINIC_MATCHING_FAILURE')
    },
    [NS_CLINIC_AUTOCOMPLETE_CLEAR] (state) {
      console.log('NS_CLINIC_AUTOCOMPLETE_CLEAR')
      state.clinics = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ns-clinic.js